export const faWelcomeContent = [
  {
    head: "Download Authenticator App",
    description: `If you haven’t already, download and install a 2FA app of your choice from your app/play store (e.g., Google Authenticator, Authy). Once installed, open the app on your device.`,
  },
  {
    head: "Scan QR Code or Enter Secret Key",
    description: `In the 2FA app, navigate to the option to scan a QR code. Then, scan the QR code  or manually enter the secret key. This will link your account to the 2FA app.`,
  },
  {
    head: "Enter Code",
    description: `After scanning or entering the secret key, the app will generate a six-digit code. Enter this code to complete the setup.`,
  },
  {
    head: "Backup Codes",
    description: `As a precaution, we recommend saving your backup codes in a secure location. These codes can be used to access your account if you’re unable to use the 2FA.`,
  },
];
